import { Component } from '@angular/core';

@Component({
  selector: 'app-register-carrier-invite',
  templateUrl: './register-carrier-invite.component.html',
  styleUrls: ['./register-carrier-invite.component.scss'],
})
export class RegisterCarrierInviteComponent {

  constructor() { }

}
